import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(3),
      height: 44,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',

      '&.similar-schools': {
        height: 64,
      },

      '& > * + *': {
        marginTop: theme.spacing(1),
      },
    },
    collapseContainer: {
      display: 'flex',
      maxWidth: '100%',
      paddingTop: theme.spacing(0.5),

      '&.top-bordered': {
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        paddingTop: 0,
      },
    },
    collapseContent: {
      width: 220,
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    noPaddingLeft: {
      paddingLeft: theme.spacing(1),
    },
  }),
);
